import { FC, PropsWithChildren } from "react";
import style from "./style.module.scss";

type CollapsibleProps = { isOpen: boolean } & PropsWithChildren;

export const Collapsible: FC<CollapsibleProps> = ({ isOpen, children }) => (
  <div
    className={`${style.collapsible} ${
      isOpen ? style["collapsible__open"] : ""
    }`}
  >
    {children}
  </div>
);
